const getVisualValue = async (visualName) => {
  //@ts-ignore
  const activePage = await window.report.getActivePage();
  const pageVisuals = await activePage.getVisuals();
  const visual = pageVisuals.find((visual) => visualName === visual.name && visual.type === 'slicer');
  return visual;
};

export const extractVisualDataWithReportDetails = async (event) => {
  let visualName = '';
  let visualValues = '';
  if (event?.detail?.visual?.name) {
    const visual = await getVisualValue(event?.detail?.visual?.name);
    if (visual) {
      const settings = await visual.getSlicerState();
      if (settings?.filters && settings.filters.length > 0 && settings.filters[0].values) {
        visualValues = settings.filters[0].values.join(','); //filters always have single filter value on the index 0
      }
    }
  }
  return {
    pageName: event?.detail?.page?.displayName,
    report: event?.detail?.report?.displayName,
    visualValues,
    visualName,
  };
};

export const fireHeapEvent = (eventName: string, eventData, workspaceName) => {
  if (window._env_.HEAP_ENABLED && window.heap) {
    window.heap.track(eventName, {
      workspace: workspaceName,
      userId: window.__preqinUser.id,
      firmId: window.__preqinUser.firmId,
      firmType: window.__preqinUser.firmType,
      internal: window.__preqinUser.internal,
      ...eventData,
    });
  }
};
